<div *ngIf="!onlyTimezone" class="col-sm-12 time_header border " style="border-radius: 5px;">
      <form>
          <div class="form-group position_input custome_date border-0 ">
            <button id="date-picker-btn" name="date-picker-btn" class="btn btn-primary time_stamp_btn waves-effect waves-light border-0" align="right" 
            style="font-size: 11px !important;height:auto">
                <div class="left_div">
                    <i class="fa fa-calendar-alt" ></i>
                </div>
                <div class="right_div">
                    <div>
                        <a id="label-startdate" name="label-startdate" class="ancher_tg">Start Date : </a> <span id="startdate" name="startdate"> 
                             <!-- 28-04-2022 18:39 -->
                             {{selectedRange?.startDate | daterangeformatter: 'DD-MM-YYYY HH:mm':selectedTimezone}}
                            </span>
                    </div>
                    <div class="end_date">
                        <a id="label-enddate" name="label-enddate" class="ancher_tg">End Date : </a> <span id="enddate" name="enddate"> 
                            <!-- 28-04-2022 18:54 -->
                            {{selectedRange?.endDate | daterangeformatter: 'DD-MM-YYYY HH:mm':selectedTimezone}}
                        </span>
                    </div>
                         
                </div>

               </button>
    <input id="datepicker" style="color: transparent !important;height:100%; border: none !important"
      type="text" 
      name="daterange"
      autocomplete="off" readonly
      customattach
      ngxDaterangepickerMd
      (datesUpdated)="choosedDate($event)"
      (rangeClicked)="handleRangeClick($event)"
      [(ngModel)]="selectedRange" 
      [ngModelOptions]="{standalone: true}"
      [alwaysShowCalendars]="true"
      [showCustomRangeLabel]="true"
      [showClearButton]="true"
      [showDropdowns]="true"
      [linkedCalendars]="false"
      [ranges]="ranges"
      [locale]="calendarLocale" 
      [placeholder]="calendarPlaceholder"
      [keepCalendarOpeningWithRange]="true" 
      [minDate]="minDate"
      [maxDate]="maxDate"
      [timePicker]="true"
      [timePicker24Hour]="true"
      [timePickerIncrement]="1"
      [timePickerSeconds]="false"
      class="form-control date_inputField" />
          </div>

  

      </form> 
      
      <!-- Timezone row below calendar -->
<div *ngIf="showTimezone" class="tz-row">
    <p-dropdown
        [options]="timezones"
        [(ngModel)]="selectedTimezone"
        (onChange)="handleTimezoneChange($event)"
        (click)="handleClick($event)"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        filterPlaceholder="Search timezone..."
        [showClear]="false"
        appendTo="body"
        (onShow)="onDropdownShow($event)"
        styleClass="no-border-dropdown timezone-dropdown"
        panelStyleClass="custom-dropdown-header">
    </p-dropdown>
    <button class="tz-reset-btn"
        (click)="handleResetTimeZone($event)"
        title="Reset to local timezone">
        <fa-icon [icon]="loading ? faRefresh : faGlobe" [ngClass]="{'loader-refresh': loading}"></fa-icon>
    </button>
</div>

</div>

<div *ngIf="onlyTimezone" class="tz-standalone">
    <p-dropdown
        [options]="timezones"
        [(ngModel)]="selectedTimezone"
        (onChange)="handleTimezoneChange($event)"
        (click)="handleClick($event)"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        filterPlaceholder="Search timezone..."
        [showClear]="false"
        appendTo="body"
        (onShow)="onDropdownShow($event)"
        styleClass="no-border-dropdown onlytimezone"
        panelStyleClass="custom-dropdown-header">
    </p-dropdown>
    <button class="tz-reset-btn"
        (click)="handleResetTimeZone($event)"
        title="Reset to local timezone">
        <fa-icon [icon]="loading ? faRefresh : faGlobe" [ngClass]="{'loader-refresh': loading}"></fa-icon>
    </button>
</div>
